/**
 * 직종 → 이름 정렬 (임금대장·임금설정·명세서 공통)
 *
 * 시설장(센터장)부터 요양보호사까지 고정 순서.
 * 같은 순위 안에서는 직종명, 그 다음 이름(가나다).
 * 목록에 없는 직종은 요양보호사 다음, 직종명 가나다순.
 */

const JOB_TYPE_SORT_RULES: Array<(job: string) => boolean> = [
  (job) => job.includes('시설장'),
  (job) => job.includes('센터장'),
  (job) => job.includes('사무국장'),
  (job) => job.includes('사회복지사'),
  (job) => job.includes('사무원') || (job.includes('사무') && !job.includes('국장')),
  (job) => job.includes('관리인'),
  (job) => job.includes('간호') && !job.includes('조무'),
  (job) => job.includes('간호조무'),
  (job) => job.includes('물리치료'),
  (job) => job.includes('작업치료'),
  (job) => job.includes('영양'),
  (job) => job.includes('조리사'),
  (job) => job.includes('조리원') || (job.includes('조리') && !job.includes('조리사')),
  (job) => job.includes('위생'),
  (job) => job.includes('운전'),
  (job) => job.includes('요양보호사'),
  (job) => job.includes('기타'),
];

const UNKNOWN_JOB_RANK = 900;
const EMPTY_JOB_RANK = 10000;

export function getJobTypeSortRank(jobType: string | null | undefined): number {
  const job = String(jobType || '').trim();
  if (!job) return EMPTY_JOB_RANK;
  const index = JOB_TYPE_SORT_RULES.findIndex((match) => match(job));
  return index >= 0 ? index : UNKNOWN_JOB_RANK;
}

/** 직종 순위 → 같은 직종이면 이름 */
export function compareJobThenName(
  jobA: string | null | undefined,
  nameA: string | null | undefined,
  jobB: string | null | undefined,
  nameB: string | null | undefined
): number {
  const rankA = getJobTypeSortRank(jobA);
  const rankB = getJobTypeSortRank(jobB);
  if (rankA !== rankB) return rankA - rankB;
  const jobCmp = String(jobA || '').localeCompare(String(jobB || ''), 'ko');
  if (jobCmp !== 0) return jobCmp;
  return String(nameA || '').localeCompare(String(nameB || ''), 'ko');
}
